document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-sticky-purchase]').forEach((bar) => {
    const targetId = bar.dataset.targetId;
    const target = targetId ? document.getElementById(targetId) : null;

    const updateFallback = () => {
      if (target) return;
      bar.classList.toggle('is-visible', window.scrollY > 420);
    };

    if ('IntersectionObserver' in window && target) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          const hasScrolled = window.scrollY > 260;
          bar.classList.toggle('is-visible', !entry.isIntersecting && hasScrolled);
        },
        { threshold: 0.15 }
      );

      observer.observe(target);
      window.addEventListener('scroll', () => {
        if (window.scrollY <= 260) bar.classList.remove('is-visible');
      }, { passive: true });
    } else {
      updateFallback();
      window.addEventListener('scroll', updateFallback, { passive: true });
    }
  });

  document.querySelectorAll('.lux-quantity').forEach((control) => {
    const input = control.querySelector('[data-quantity-input]');
    if (!input) return;

    control.querySelectorAll('[data-quantity-change]').forEach((button) => {
      button.addEventListener('click', () => {
        const change = Number(button.dataset.quantityChange || 0);
        const current = Number(input.value || 0);
        input.value = Math.max(0, current + change);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
});
